import React from "react";
import { Sun, Mail, Facebook, Instagram, Youtube } from "lucide-react";
import { SOCIALS } from "@/lib/site-config";

const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export default function SiteFooter() {
  return (
    <footer className="py-16 bg-[var(--navy-deep)] text-[var(--cream)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-full bg-[var(--terracotta)] flex items-center justify-center text-[var(--cream)]">
              <Sun className="w-5 h-5" />
            </span>
            <span className="font-serif text-xl text-[var(--cream)]">Get to Spain</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed max-w-xs text-[var(--cream)]/90">
            Personal, practical support for your move to Spain — through the Non-Lucrative
            Visa or with an EU passport.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-[var(--gold)] font-medium">Explore</div>
          <ul className="mt-4 space-y-2.5 text-sm text-[var(--cream)]/90">
            <li><a href="/nlv-approved" className="hover:text-[var(--gold)] transition-colors">NLV Approved</a></li>
            <li><a href="/eu-approved" className="hover:text-[var(--gold)] transition-colors">EU Approved</a></li>
            <li><a href="/masterclass" className="hover:text-[var(--gold)] transition-colors">NLV Masterclass</a></li>
            <li><a href="/tools" className="hover:text-[var(--gold)] transition-colors">Free tools</a></li>
            <li><a href="/about" className="hover:text-[var(--gold)] transition-colors">About Carley</a></li>
            <li><a href="/client-success" className="hover:text-[var(--gold)] transition-colors">Client success</a></li>
            <li><a href="/nlv-approved#book" className="hover:text-[var(--gold)] transition-colors">Book a call</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-[var(--gold)] font-medium">Connect</div>
          <ul className="mt-4 space-y-3 text-sm text-[var(--cream)]/90">
            <li>
              <a
                href={SOCIALS.facebook}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 hover:text-[var(--gold)] transition-colors"
                data-testid="footer-facebook"
              >
                <Facebook className="w-4 h-4" /> Carley on Facebook
              </a>
            </li>
            <li>
              <a
                href={SOCIALS.instagram}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 hover:text-[var(--gold)] transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-4 h-4" /> Carley on Instagram
              </a>
            </li>
            <li>
              <a
                href={SOCIALS.tiktok}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 hover:text-[var(--gold)] transition-colors"
                data-testid="footer-tiktok"
              >
                <TikTokIcon className="w-4 h-4" /> Carley on TikTok
              </a>
            </li>
            <li>
              <a
                href={SOCIALS.youtube}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 hover:text-[var(--gold)] transition-colors"
                data-testid="footer-youtube"
              >
                <Youtube className="w-4 h-4" /> Carley on YouTube
              </a>
            </li>
            <li>
              <a
                href="https://m.me/gettospain"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 hover:text-[var(--gold)] transition-colors"
                data-testid="footer-message"
              >
                <Mail className="w-4 h-4" /> Message me on Facebook
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12 pt-6 border-t border-[var(--cream)]/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[var(--cream)]/75">
        <div>© {new Date().getFullYear()} Get to Spain · NLV Approved &amp; EU Approved by Carley Chaplin</div>
        <div>Spaces are limited — speak soon.</div>
      </div>
    </footer>
  );
}
